import React from 'react';
import './focusSection.scss'
import FacebookPixel from '@images/homepage/focus/features/facebook-pixel.svg'
import GoogleAnalytics from '@images/homepage/focus/features/google-analytics.svg'
import GoogleCalendar from '@images/homepage/focus/features/google-calendar.svg'
import GoogleTagManager from '@images/homepage/focus/features/google-tag-manager.svg'
import MailChimp from '@images/homepage/focus/features/mailchimp.svg'
import OutlookCalendar from '@images/homepage/focus/features/outlook-calendar.svg'
import SendFox from '@images/homepage/focus/features/send-fox.svg'
import Zapier from '@images/homepage/focus/features/zapier.svg'
import Zoom from '@images/homepage/focus/features/zoom.svg'
import Authorize from '@images/homepage/focus/features/authorize-net.svg'
import Molli from '@images/homepage/focus/features/molli.svg'
import Stripe from '@images/homepage/focus/features/stripe.svg'
import Paypal from '@images/homepage/focus/features/paypal.svg'
import {ParallaxProvider, Parallax} from 'react-scroll-parallax';
import {StaticImage} from "gatsby-plugin-image";

function FocusSection() {

  const featureIcons = [
    {
      'icon': FacebookPixel
    },
    {
      'icon': GoogleTagManager
    },
    {
      'icon': MailChimp
    },
    {
      'icon': GoogleCalendar
    },
    {
      'icon': Zapier
    },
    {
      'icon': SendFox
    },
    {
      'icon': OutlookCalendar
    },
    {
      'icon': Zoom
    },
    {
      'icon': GoogleAnalytics
    },
    {
      'icon': Authorize
    },
    {
      'icon': Molli
    },
    {
      'icon': Paypal
    },
    {
      'icon': Stripe
    }
  ]

  return (
    <ParallaxProvider>
      <div className='homepage-fs-wrapper'>
        <div className='homepage-fs-wrapper__focus-section'>
          <div className='homepage-fs-wrapper__focus-section__headline'>
              <h2>
                Focus on your work, we will take care of the rest
              </h2>
            <div className='homepage-fs-wrapper__focus-section__headline__subtitle'>
              Our online booking software helps you optimize your daily schedule and have more time to do what you do best.
            </div>
          </div>
          <div className='homepage-fs-wrapper__focus-section__cards'>
            <div className='homepage-fs-wrapper__focus-section__cards__tools'>
              <div className='homepage-fs-wrapper__focus-section__cards__tools__rows'>
                <div className='homepage-fs-wrapper__focus-section__cards__tools__rows__icons-first'>
                  {featureIcons.map((feature) => (
                    <Parallax key={feature.icon} speed={0} style={{width: '72px', height: '72px'}}
                              translateX={[0, 50]}>
                      <div className='homepage-fs-wrapper__focus-section__cards__tools__rows__icons-first__icon-wrapper'>
                        <img width='36' height='36' src={feature.icon} alt='' loading="lazy"/>
                      </div>
                    </Parallax>
                  ))}
                </div>
                <div className='homepage-fs-wrapper__focus-section__cards__tools__rows__icons-second'>
                  {featureIcons.sort(() => Math.random() - 0.5).map((feature) => (
                    <Parallax key={feature.icon} speed={0} style={{width: '72px', height: '72px'}}
                              translateX={[50, 0]}>
                      <div className='homepage-fs-wrapper__focus-section__cards__tools__rows__icons-second__icon-wrapper'>
                        <img width='36' height='36' src={feature.icon} alt='' loading="lazy"/>
                      </div>
                    </Parallax>
                  ))}
                </div>
              </div>
              <div className='homepage-fs-wrapper__focus-section__cards__tools__text'>
                <h3>
                  Connect your productivity tools with Trafft
                </h3>
                <div className='homepage-fs-wrapper__focus-section__cards__tools__text__subtitle'>
                  Trafft integrates and connects all the different online tools a modern business needs, such as calendars, payments, Google Meet, Google Analytics, Zapier integration and many more. If you don't see your favorite tool among our integrations, let us know, and we will give our best to meet your needs.
                </div>
              </div>
            </div>
            <div className='homepage-fs-wrapper__focus-section__cards__employee'>
              <div className='homepage-fs-wrapper__focus-section__cards__employee__images'>
                <div className='homepage-fs-wrapper__focus-section__cards__employee__images__persons'>
                  <StaticImage width={367} src='../../../images/homepage/focus/persona.webp' alt='Trafft booking calendar' />
                </div>
                <div className='homepage-fs-wrapper__focus-section__cards__employee__images__calendar'>
                  <StaticImage width={437} src='../../../images/homepage/focus/calendar.webp' alt='Trafft booking calendar' />
                </div>
              </div>
              <div className='homepage-fs-wrapper__focus-section__cards__employee__text'>
                <h3>Manage all the schedules in one calendar</h3>
                <div className='homepage-fs-wrapper__focus-section__cards__employee__text__subtitle'>
                  Forget about the nightmare of checking availability for each one of your team members individually.
                  Integrate all of your employees' calendars with Trafft, and manage all schedules in one place.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ParallaxProvider>
  )
}

export default FocusSection